import { atom } from 'jotai';

export const menuOverlayAtom = atom<React.ReactElement | string>('');
